export type LineHeight = 'COMPACT' | 'SHORT' | 'DEFAULT' | 'TALL' | 'THUMBNAIL';
export const LineHeightToPx: Record<LineHeight, number> = {
  COMPACT: 28,
  SHORT: 32,
  DEFAULT: 40,
  TALL: 58,
  THUMBNAIL: 98
};

/**
 * Returns a Tailwind padding class appropriate for the given row/header height.
 * COMPACT and SHORT use reduced vertical padding so the row height takes effect;
 * otherwise the cell content (text + padding) would overflow the declared height.
 */
export const getRowPaddingClass: Record<LineHeight, string> = {
  COMPACT: 'py-0.5 px-2',
  SHORT: 'py-1 px-2',
  DEFAULT: 'p-2',
  TALL: 'p-2',
  THUMBNAIL: 'p-2'
};

/**
 * Total vertical padding (top + bottom) in pixels that corresponds to each
 * getRowPaddingClass entry.  Used by ThumbnailCellRenderer to shrink the image
 * so that image + padding = row height exactly.
 *   py-0.5 → 2 + 2 = 4px
 *   py-1   → 4 + 4 = 8px
 *   p-2    → 8 + 8 = 16px
 */
export const getRowVerticalPaddingPx: Record<LineHeight, number> = {
  COMPACT: 4,
  SHORT: 8,
  DEFAULT: 16,
  TALL: 16,
  THUMBNAIL: 16
};